import React, {memo, useEffect} from 'react';
import theme from './style';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import Grid from '@material-ui/core/Grid';
import Label from '../label';
import {TextInput, BorderSelect} from '../inputs'
import translate from '../../misc/applyTranslation';
import {patchCustomerObject} from '../../redux/actions/customer/customerDetail';
import {fetchCustomerTypes} from '../../redux/actions/invoices';
import {fetchCustomerTags, fetchDeliveryTypes} from '../../redux/actions/settings';
import {useConfig} from "../../context/configContext";

const CustomerPanel = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const {
    access_token,
    refresh_token,
    data,
    patchCustomerObject,
    delivery_types,
    fetchCustomerTypes,
    fetchCustomerTags,
    tags,
    invalidFields,
    fetchDeliveryTypes
  } = props;

  const handleOnChange = (value, key) => {
    patchCustomerObject({
      key: key,
      value: value,
    })
  }

  useEffect(() => {
    fetchCustomerTypes({
      access_token,
      refresh_token,
    })
    fetchCustomerTags({
      access_token,
      refresh_token,
    })
    fetchDeliveryTypes({
      access_token: access_token,
      refresh_token: refresh_token
    })
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (tags.length > 0) {
     /* patchCustomerObject({
        key: "special_cust",
        value: "1",
      })*/
      patchCustomerObject({
        special_cust: "1",
        delivery: data.email1.length > 0 ? "2" : "1",
      })
    }
    // eslint-disable-next-line
  }, [tags]);

/*  useEffect(() => {
    if (hasRun.current) return; // ensure it only runs once

    console.log("Updating delivery based on email1:", data.email1);
    const value = data.email1.length > 0 ? "2" : "1";
    patchCustomerObject({
      key: "delivery",
      value,
    });

    hasRun.current = true; // mark as done
  }, [data.email1]);

  console.log(data)*/
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <Label text={translate('customers/detail', 'customer_edit_panel_personal_nr')}/>
        <TextInput invalid={invalidFields && invalidFields.includes('ssn')} value={data.ssn} onChange={(e) => {
          if (!isNaN(e.target.value)) {
            handleOnChange(e.target.value, 'ssn')
          }
        }}/>
      </Grid>
      <Grid item xs={12}>
        <Label text={translate('customers/detail', 'customer_edit_panel_name')}/>
        <TextInput invalid={invalidFields && invalidFields.includes('name')} value={data.name}
                   onChange={(e) => handleOnChange(e.target.value, 'name')}/>
      </Grid>
      <Grid item xs={12}>
        <Label text={translate('customers/detail', 'customer_edit_panel_co')}/>
        <TextInput value={data.name2} onChange={(e) => handleOnChange(e.target.value, 'name2')}/>
      </Grid>
      <Grid item xs={12}>
        <Label text={translate('customers/detail', 'customer_edit_panel_address')}/>
        <TextInput invalid={invalidFields && invalidFields.includes('address1')} value={data.address1}
                   onChange={(e) => handleOnChange(e.target.value, 'address1')}/>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Label text={translate('customers/detail', 'customer_edit_panel_postal_code')}/>
        <TextInput invalid={invalidFields && invalidFields.includes('post_code')} value={data.post_code}
                   onChange={(e) => handleOnChange(e.target.value, 'post_code')}/>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Label text={translate('customers/detail', 'customer_edit_panel_city')}/>
        <TextInput invalid={invalidFields && invalidFields.includes('city')} value={data.city}
                   onChange={(e) => handleOnChange(e.target.value, 'city')}/>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Label text={translate('customers/detail', 'customer_edit_panel_country')}/>
        <TextInput invalid={invalidFields && invalidFields.includes('country')} value={data.country}
                   onChange={(e) => handleOnChange(e.target.value, 'country')}/>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Label text={translate('customers/detail', 'customer_edit_panel_special_cust')}/>
        {(tags && tags.length > 0) &&
          <BorderSelect
            onChange={(e) => handleOnChange(e, 'special_cust')}
            selected={data.special_cust}
            items={tags}
          />
        }
      </Grid>
      <Grid item xs={12}>
        <Label text={translate('customers/detail', 'customer_edit_panel_email')}/>
        <TextInput value={data.email1} type='email' invalid={invalidFields && invalidFields.includes('email1')}
                   onChange={(e) => handleOnChange(e.target.value, 'email1')}/>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Label text={translate('customers/detail', 'customer_edit_panel_mobile')}/>
        <TextInput value={data.tel1} type='tel' onChange={(e) => handleOnChange(e.target.value, 'tel1')}/>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Label text={translate('customers/detail', 'customer_edit_panel_homephone')}/>
        <TextInput value={data.tel2} onChange={(e) => handleOnChange(e.target.value, 'tel2')}/>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Label text={translate('customers/detail', 'customer_edit_panel_delivery')}/>
        <BorderSelect
          invalid={invalidFields && invalidFields.includes('delivery')}
          onChange={(e) => handleOnChange(e, 'delivery')}
          selected={data.delivery}
          items={delivery_types}
        />
      </Grid>
      <Grid item xs={12} sm={6}/>
    </Grid>
  );

}
CustomerPanel.propTypes = {
  patchCustomerObject: PropTypes.func.isRequired,
  access_token: PropTypes.string.isRequired,
  refresh_token: PropTypes.string.isRequired,
  delivery_types: PropTypes.array.isRequired,
  tags: PropTypes.array.isRequired,
}
const mapStateToProps = store => ({
  access_token: store.login.access_token,
  refresh_token: store.login.refresh_token,
  delivery_types: store.settings.delivery_types,
  tags: store.settings.tags,
  data: store.customer.customerData,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({
    patchCustomerObject,
    fetchCustomerTypes,
    fetchCustomerTags,
    fetchDeliveryTypes
  }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(memo(CustomerPanel));